import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Card } from 'components';
import { Button, Heading, Text } from 'components/chroma';

import { PolicyHolder, YesNoAnswer } from 'scenes/common/types';
import { toAussieStandardDateFormat } from 'scenes/common/helpers/datetime';

import { LandlordFormValues } from 'scenes/landlord/types';

const CardContainer = styled.div`
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 0.5em;
`;

export const AdditionalPolicyHolderCard: FunctionComponent<{
  policyHolder: PolicyHolder;
  policyHolderIndex: number;
  onClickEdit: (values: LandlordFormValues) => void;
  onClickRemove: (policyHolderIndex: number) => void;
}> = ({
  policyHolder: { firstName, lastName, dob },
  policyHolderIndex,
  onClickEdit,
  onClickRemove,
}) => (
  <Card
    id={`${firstName}${lastName}`}
    center
    justify
    tabIndex={-1}
    role="listitem"
  >
    <CardContainer>
      <Heading size={4} margin={{ bottom: 1 }}>
        {firstName}&nbsp;
        {lastName}
      </Heading>
      <Text>{toAussieStandardDateFormat(dob)}</Text>
      <ButtonContainer>
        <Button
          link
          ariaLabel="Modify"
          onClick={() =>
            onClickEdit({
              addAdditionalPolicyHolder: YesNoAnswer.Yes,
              additionalPolicyHolderIndex: policyHolderIndex,
            })
          }
        >
          Modify
        </Button>
        <Button
          link
          ariaLabel="Remove"
          onClick={() => onClickRemove(policyHolderIndex)}
          margin={{ left: 4 }}
        >
          Remove
        </Button>
      </ButtonContainer>
    </CardContainer>
  </Card>
);
